import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1538aa99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "_page_wrap" }
const _hoisted_2 = {
  class: "_page_block_clients",
  mark: "blocktitle"
}
const _hoisted_3 = { class: "_block_title1 _priv_title" }
const _hoisted_4 = { class: "_block_container" }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "_block_piece",
  mark: "blocktitle"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scroll_enter = _resolveComponent("scroll-enter")!
  const _component_Isotope = _resolveComponent("Isotope")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.currTab.replace('\n', '')), 1),
      _createVNode(_component_Isotope, {
        class: "_block_piece_children",
        initialize: _ctx.isoInitialize,
        activated: _ctx.windowWidth>700,
        onNewWidth: _cache[0] || (_cache[0] = newWidth=>_ctx.handleNewWidth(newWidth, 'blocktitle'))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData[_ctx.currTab.replace('\n', '')], (b1, b1Index) => {
            return (_openBlock(), _createBlock(_component_scroll_enter, {
              class: "iso_item",
              _inactive: b1Index<4,
              duration: 1,
              key: b1.title
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "_block_title",
                    title: b1.title
                  }, _toDisplayString(b1.title), 9, _hoisted_5),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(b1.children, (b2) => {
                    return (_openBlock(), _createElementBlock("a", {
                      class: "_block_content default_text",
                      key: b2.title,
                      onClick: ($event: any) => (_ctx.window.open(b2.url, '_blank'))
                    }, _toDisplayString(b2.title), 9, _hoisted_6))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1032, ["_inactive"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["initialize", "activated"]),
      _hoisted_7
    ])
  ]))
}